// extracted by mini-css-extract-plugin
export default {"header":"CeFqSm","subHeading":"sU4xaT"};